import { ConsultationRequestError } from '@errors/consultation-request-error';

export class MissingStoreAttachmentTokenError extends ConsultationRequestError {
  public constructor(contact: string) {
    super(
      `We encountered an error while uploading your attachments. Please contact customer service at ${contact} for assistance.`,
    );
  }
}
